var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "20px",
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calendar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2,
    transform: "translate(-360.000000, -488.000000)",
    fill: "#393939",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(361.000000, 489.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(-1.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.52941176,13.0743034 C5.01973931,13.0743034 2.17647059,10.212329 2.17647059,6.68421053 C2.17647059,3.15609209 5.01973931,0.294117647 8.52941176,0.294117647 C12.0390842,0.294117647 14.8823529,3.15609209 14.8823529,6.68421053 C14.8823529,10.212329 12.0390842,13.0743034 8.52941176,13.0743034 Z M8.52941176,11.6625387 C11.2573083,11.6625387 13.4705882,9.43469766 13.4705882,6.68421053 C13.4705882,3.93372339 11.2573083,1.70588235 8.52941176,1.70588235 C5.80151528,1.70588235 3.58823529,3.93372339 3.58823529,6.68421053 C3.58823529,9.43469766 5.80151528,11.6625387 8.52941176,11.6625387 Z",
    id: "Oval-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.48418716,19.0399623 C1.20050805,19.3073714 0.753762718,19.2941821 0.486353534,19.0105029 C0.21894435,18.7268238 0.232133732,18.2800785 0.515812842,18.0126693 C2.77923379,15.879063 5.54113935,14.8072869 8.76470588,14.8072869 C11.9882724,14.8072869 14.750178,15.879063 17.0135989,18.0126693 C17.297278,18.2800785 17.3104674,18.7268238 17.0430582,19.0105029 C16.775649,19.2941821 16.3289037,19.3073714 16.0452246,19.0399623 C14.0466791,17.1560398 11.632114,16.2190516 8.76470588,16.2190516 C5.89729773,16.2190516 3.4827327,17.1560398 1.48418716,19.0399623 Z",
    id: "Line"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/person-icon.9c8cb6bd67b1443c2e50cdb80ea54131.svg";
export { ForwardRef as ReactComponent };